var React = require('react');

function Comments (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26 12c0 5.525-5.819 10-13 10-2.563 0-4.944-.581-6.956-1.563C4.682 21.231 2.788 22 .5 22c-.2 0-.375-.113-.456-.3s-.044-.4.094-.544c.019-.019 1.4-1.519 2.237-3.406C.881 16.119 0 14.144 0 12 0 6.475 5.819 2 13 2s13 4.475 13 10zm7.625 13.75c.838 1.894 2.219 3.387 2.237 3.406A.5.5 0 0 1 35.5 30c-2.287 0-4.181-.769-5.544-1.563C27.944 29.425 25.562 30 23 30c-5.387 0-10.012-2.525-11.981-6.119.65.069 1.306.119 1.981.119 8.269 0 15-5.381 15-12a9.32 9.32 0 0 0-.081-1.256C32.657 12.238 36 15.819 36 20c0 2.144-.881 4.125-2.375 5.75z"}));
}

Comments.defaultProps = {"viewBox":"0 0 36 32"};

module.exports = Comments;

Comments.default = Comments;
